import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DxButtonModule, DxTextBoxModule, DxPopupModule, DxScrollViewModule, DxToastModule } from 'devextreme-angular';
import { CtlTmsDemirbasAramaComponent } from './ctl-tms-demirbas-arama/ctl-tms-demirbas-arama.component';
import { TmsDemirbasService} from './ctl-tms-demirbas.service';
import { CommonModule } from '@angular/common';
import { CtlSablonComponent, OrtakService, UtilsService } from '@dabnet-kamu/libs/ui';
import { LabelMode } from 'devextreme/common';

@Component({
  selector: 'dk-ctl-tms-demirbas',
  standalone: true,
  imports: [
    DxTextBoxModule,
    DxButtonModule,
    CtlTmsDemirbasAramaComponent,
    CommonModule,
    DxPopupModule,
    DxScrollViewModule,
    CtlSablonComponent,
    DxToastModule
  ],
  providers: [TmsDemirbasService],
  templateUrl: './ctl-tms-demirbas.component.html',
  styleUrls: ['./ctl-tms-demirbas.component.scss'],
})
export class CtlTmsDemirbasComponent implements OnInit, OnChanges {
  @ViewChild(CtlSablonComponent) ctlSablonComponent: CtlSablonComponent;
  @Input() labelText = "";
  @Input() islemTuru:string;
  @Input() labelMode:LabelMode = null;
  public crudPopupVisible = false;
  public title!: string;
public isFirst = true;
  public control!: any;
  controlName = "vTmsZimmetTerkinDus";
  @Input() isReadOnly = false;
  @Input() isBindCheck = false;
  public toastMessage: string;
  public toastVisible = false;
  public showAction = true;
  public data: any;
  @Input() code: any;
  @Input() ambarKod!: any;
  @Input() verilenPersonelKod!: any;
  @Input() demirbasYerKod!: any;
  @Input() validationRulesMap!:any[];
  @Input() validationV2 = false;
  @Input() warningMessage: string | null = null;
  @Output() public dataResult: EventEmitter<any> = new EventEmitter();

  constructor(private service: TmsDemirbasService, private utilsService: UtilsService, private ortakService: OrtakService) {}

  ngOnInit(): void {
    if (this.controlName) {
      this.getControl();
    }
      this.service.setParams(this.ambarKod, this.verilenPersonelKod, this.demirbasYerKod, this.islemTuru,this.isReadOnly,this.isBindCheck)
  }

  ngOnChanges(changes: SimpleChanges) {
    this.showAction = true
    if(changes['ambarKod'] || changes['verilenPersonelKod'] || changes['demirbasYerKod']){
      this.service.setParams(this.ambarKod, this.verilenPersonelKod, this.demirbasYerKod, this.islemTuru,this.isReadOnly,this.isBindCheck)
    }
    if (changes['isReadOnly'] || changes['isBindCheck']) {
      this.service.setParams(this.ambarKod, this.verilenPersonelKod, this.demirbasYerKod, this.islemTuru,this.isReadOnly,this.isBindCheck)
      }
  }
  getControl(){
    this.ortakService.getControl(this.controlName)
    .subscribe((data) => {
      this.control = data?.controlMetadata;
             //this.service.getDlist(this.control?.dlistCode);
      this.service._gridControlsList.next(data?.controlMetadata.dlistMetadata)
      //if(this.labelText === "")this.labelText = this.control.controlDescription;
        if(data?.controlMetadata.dlistMetadata.baseEntity){
          if(this.labelText === "")this.labelText = this.control.controlDescription;
          if(this.code && this.control) this.getData(this.code,true)
if(this.isFirst) this.isFirst = false;;
        }
    });
  }




  searchClick() {
    if(this.showAction) this.crudPopupVisible = true
    else this.toastVisible = true
  }

  clear() {
    this.title = '';
    this.code = '';
    this.data = null;
    this.dataResult.emit(null);
  }

  handleValueChange(e: any) {
    if(this.showAction){
      if (e === '' || e === null) this.clear();
      else if(!this.isFirst) this.getData(e);
    this.isFirst = false;
    }
    else this.toastVisible = true
  }

  getData(code: any, isSetData?: boolean) {
    this.data = this.service.getData(code,this.control, this.ambarKod, this.verilenPersonelKod, this.demirbasYerKod, this.islemTuru, this.control.dlistMetadata.baseEntity,isSetData);
    this.data.load().done((result: any) => {
      if (result.length > 0) {
        this.title = result[0].Ad;
        this.code = result[0].SicilKod;
        this.dataResult.emit(result[0]);
      } else if (this.code.length > 0) {
        this.utilsService.showError('Bulunamadı');
        this.clear();
      }

    });

  }

  closePopupAfter(result: any, sablonCmp: CtlSablonComponent) {
    if (result?.data) {
      this.data = result.data;
      this.code = result.data.SicilKod;
      this.dataResult.emit(this.data);
    }
    this.crudPopupVisible = false;
    setTimeout(() => {
      sablonCmp.focusInput();
    });
  }
}

